var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"v-footer font-weight-medium shadow-sm ma-4 rounded-lg v-sheet theme--light rounded-0 v-footer--inset white",staticStyle:{"height":"80px"},attrs:{"data-booted":"true"}},[_c('div',{staticClass:"text-left col col-12"},[_c('div',{staticClass:"text-center align-center"},[_c('div')])])])
}]

export { render, staticRenderFns }